import { render } from "./OpenIndicator.vue?vue&type=template&id=b0eb3f54"
const script = {}

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__